module.exports = __webpack_public_path__ + "img/banner100kata21.7640d9f5.jpg";